import React from 'react';

import classnames from 'classnames';

import './TriggerIcon.scss';

type WrapTag = 'button' | 'span' | 'div';
export interface TriggerIconProps {
  tag?: WrapTag;
  children: React.ReactElement;
  className?: string;
  isDisabled?: boolean;
  tiny?: boolean;
}

function _TriggerIcon(
  { tag: Wrapper = 'span', className, children, isDisabled = false, tiny = false, ...props }: TriggerIconProps,
  ref: React.RefObject<any>
): React.ReactElement {
  const classNames = classnames('icon', className, {
    disabled: isDisabled,
    tiny: tiny,
  });

  return (
    <Wrapper className={classNames} {...props} ref={ref}>
      {children}
    </Wrapper>
  );
}

export const TriggerIcon = React.forwardRef(_TriggerIcon);
